import { render, staticRenderFns } from "./DownloadReportXslx.vue?vue&type=template&id=4d189aee&"
import script from "./DownloadReportXslx.vue?vue&type=script&lang=js&"
export * from "./DownloadReportXslx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports